import { useEffect, useState } from "react";
import { EventSeriesInstance } from "../utils";

export const useExperiencesForEventSeries = (
  seriesId: number,
): {
  loading: boolean;
  upcomingExperiences: any[];
} => {
  const [loading, setLoading] = useState(true);
  const [upcomingExperiences, setUpcomingExperiences] = useState([]);

  useEffect(() => {
    setLoading(true);
    EventSeriesInstance.getLatestExperience(seriesId).then((res: any) => {
      setLoading(false);
      setUpcomingExperiences(res ?? []);
    });
  }, [seriesId]);

  return {
    loading,
    upcomingExperiences,
  };
};
